import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import DiceSkinForm from './DiceSkinForm';
// import { initialValues  } from './initialValues-testing';
import { showDiceSkinApi, updateDiceSkinApi, clearEditedDiceSkin } from './diceSkinSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { pictureAttributeNames } from './initialValue';
import uploadImage from '~/api/uploadImage';

function DiceSkinUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.itemSaga.diceSkin);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(values, pictureAttributeNames, 'dice-skins');
        dispatch(updateDiceSkinApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showDiceSkinApi({ navigate, id }));

        return () => dispatch(clearEditedDiceSkin());
    }, []);

    return (
        <DiceSkinForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default DiceSkinUpdate;
